import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { useAuth } from '../../contexts/AuthContext';
import {
  appConfigDisponivel,
  carregarLembretesAutomaticos,
  carregarModalidadesContratadas,
  carregarPushLembretes,
  carregarJornadaConfig,
  MODALIDADES_PADRAO,
  PUSH_LEMBRETES_PADRAO,
  salvarLembretesAutomaticos,
  salvarModalidadesContratadas,
  salvarPushLembretes,
  salvarJornadaConfig,
} from '../../lib/appConfig';

const card = {
  background: 'rgba(255,255,255,.78)',
  border: '1px solid rgba(216,202,182,.72)',
  borderRadius: '28px',
  padding: '22px',
  boxShadow: '0 12px 28px rgba(82,69,57,.055), inset 0 1px 0 rgba(255,255,255,.84)',
  marginBottom: '16px',
};

const input = {
  width: '100%',
  border: '1px solid rgba(151,142,134,.18)',
  borderRadius: '18px',
  padding: '12px 14px',
  fontSize: '14px',
  color: '#251c19',
  background: '#f4eee6',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'Inter, sans-serif',
};

const muted = {
  color: '#8c7f70',
  fontSize: '13px',
  lineHeight: 1.6,
};

export default function Configuracoes() {
  const { alunas } = useAuth();
  const [configOk, setConfigOk] = useState(true);
  const [modalidades, setModalidades] = useState([]);
  const [novaModalidade, setNovaModalidade] = useState('');
  const [lembretes, setLembretes] = useState('');
  const [pushAtivo, setPushAtivo] = useState(false);
  const [pushHora, setPushHora] = useState(PUSH_LEMBRETES_PADRAO.hora);
  const [pushTitulo, setPushTitulo] = useState(PUSH_LEMBRETES_PADRAO.titulo.pt);
  const [pushMensagens, setPushMensagens] = useState('');
  const [jornadaTodos, setJornadaTodos] = useState(false);
  const [jornadaAlunas, setJornadaAlunas] = useState([]);
  const [msg, setMsg] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    appConfigDisponivel().then(setConfigOk);
    carregarModalidadesContratadas().then(setModalidades);
    carregarLembretesAutomaticos().then(lista => setLembretes(lista.map(item => item.pt).join('\n')));
    carregarPushLembretes().then(config => {
      setPushAtivo(Boolean(config.ativo));
      setPushHora(config.hora || PUSH_LEMBRETES_PADRAO.hora);
      setPushTitulo(config.titulo?.pt || PUSH_LEMBRETES_PADRAO.titulo.pt);
      setPushMensagens((config.mensagens || PUSH_LEMBRETES_PADRAO.mensagens).map(item => item.pt).join('\n'));
    });
    carregarJornadaConfig().then(config => {
      setJornadaTodos(config.ativoTodos);
      setJornadaAlunas(config.alunaIds);
    });
  }, []);

  async function salvarTudo() {
    setSalvando(true);
    setMsg('');
    try {
      const linhas = lembretes.split('\n').map(l => l.trim()).filter(Boolean);
      const linhasPush = pushMensagens.split('\n').map(l => l.trim()).filter(Boolean);
      await salvarModalidadesContratadas(modalidades);
      await salvarLembretesAutomaticos(linhas.map(pt => ({ pt, en: pt })));
      await salvarPushLembretes({
        ativo: pushAtivo,
        hora: pushHora,
        titulo: { pt: pushTitulo, en: pushTitulo },
        mensagens: linhasPush.map(pt => ({ pt, en: pt })),
      });
      await salvarJornadaConfig({ ativoTodos: jornadaTodos, alunaIds: jornadaTodos ? [] : jornadaAlunas });
      setMsg('Configurações salvas.');
    } catch {
      setMsg('Não foi possível salvar no banco. Rode a migration app_config no Supabase e tente novamente.');
    }
    setSalvando(false);
  }

  function adicionarModalidade() {
    const nome = novaModalidade.trim();
    if (!nome) return;
    const nomesFixos = MODALIDADES_PADRAO.map(m => m.label.toLowerCase());
    if (!nomesFixos.includes(nome.toLowerCase()) && !modalidades.some(m => m.toLowerCase() === nome.toLowerCase())) {
      setModalidades(m => [...m, nome]);
    }
    setNovaModalidade('');
  }

  return (
    <AdminLayout>
      <div style={{ fontFamily: 'Inter, sans-serif', maxWidth: '980px' }}>
        <style>{`
          @media(max-width: 900px) {
            .admin-config-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '16px', marginBottom: '26px', flexWrap: 'wrap' }}>
          <div>
            <div style={{ color: '#895b40', fontSize: '11px', fontWeight: 800, letterSpacing: '.13em', textTransform: 'uppercase', marginBottom: '8px' }}>Sistema</div>
            <h1 style={{ fontSize: '34px', fontWeight: 700, color: '#251c19', margin: 0 }}>Configurações</h1>
            <p style={{ color: '#8c7f70', margin: '6px 0 0', fontSize: '14px', lineHeight: 1.5 }}>Ajustes gerais que afetam o app das alunas e o painel da equipe.</p>
          </div>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '9px 13px', borderRadius: '999px', background: configOk ? 'rgba(76,175,80,.08)' : 'rgba(229,57,53,.07)', color: configOk ? '#2E7D32' : '#C0392B', fontSize: '12px', fontWeight: 800 }}>
            <i style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'currentColor' }} />
            {configOk ? 'Banco conectado' : 'Banco pendente'}
          </span>
        </div>

        {!configOk && (
          <div style={{ ...card, background: 'rgba(229,57,53,0.045)', borderColor: 'rgba(229,57,53,0.18)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '44px 1fr', gap: '14px', alignItems: 'start' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '18px', display: 'grid', placeItems: 'center', background: 'rgba(229,57,53,.08)', color: '#C0392B', fontWeight: 900 }}>!</div>
              <div>
                <div style={{ color: '#C0392B', fontWeight: 800, fontSize: '15px', marginBottom: '6px' }}>Configuração do banco pendente</div>
                <div style={muted}>
                  As telas continuam funcionando com os padrões, mas para salvar modalidades e lembretes para todos os admins é preciso aplicar a migration no Supabase.
                  O arquivo já está preparado em <strong>supabase/migrations/20260715150000_app_config.sql</strong>.
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="admin-config-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.08fr) minmax(280px,.92fr)', gap: '16px', alignItems: 'start' }}>
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginBottom: '14px' }}>
            <div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: '#251c19', marginBottom: '5px' }}>Modalidades contratadas</div>
              <div style={muted}>As quatro primeiras são padrão. Adicione variações quando criar uma nova oferta.</div>
            </div>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '14px' }}>
            {MODALIDADES_PADRAO.map(m => (
              <span key={m.value} style={{ padding: '8px 12px', background: '#251C19', color: '#FAF7F2', borderRadius: '999px', fontSize: '12px', fontWeight: 800 }}>{m.label}</span>
            ))}
            {modalidades.map(m => (
              <span key={m} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f4eee6', color: '#251c19', borderRadius: '999px', fontSize: '12px', fontWeight: 700 }}>
                {m}
                <button type="button" onClick={() => setModalidades(lista => lista.filter(item => item !== m))} style={{ border: 0, background: 'transparent', color: '#8c7f70', cursor: 'pointer', padding: 0, fontSize: '15px', lineHeight: 1 }}>×</button>
              </span>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px' }}>
            <input value={novaModalidade} onChange={e => setNovaModalidade(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); adicionarModalidade(); } }} placeholder="Ex: Consultoria VIP" style={input} />
            <button type="button" onClick={adicionarModalidade} style={{ border: 0, borderRadius: '18px', padding: '0 18px', background: '#251c19', color: '#FAF7F2', fontWeight: 800, cursor: 'pointer' }}>Adicionar</button>
          </div>
        </div>

        <div style={card}>
          <div style={{ fontSize: '18px', fontWeight: 800, color: '#251c19', marginBottom: '5px' }}>Lembretes automáticos</div>
          <div style={{ ...muted, marginBottom: '14px' }}>Uma frase por linha. O app mostra uma delas por dia quando não houver recado manual recente.</div>
          <textarea value={lembretes} onChange={e => setLembretes(e.target.value)} rows={7} style={{ ...input, resize: 'vertical', lineHeight: 1.55 }} />
        </div>
        </div>

        <div style={card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'18px', flexWrap:'wrap' }}>
            <div style={{ flex:'1 1 420px' }}>
              <div style={{ fontSize:'18px', fontWeight:800, color:'#251c19', marginBottom:'5px' }}>Minha Jornada</div>
              <div style={muted}>Controla a área de fotos, stickers e linha do tempo das alunas. Enquanto estiver desativada, a Jornada não aparece no menu e o acesso direto fica bloqueado. Todo o recurso permanece preservado para ativação futura.</div>
            </div>
            <label style={{ display:'inline-flex', alignItems:'center', gap:'9px', padding:'10px 14px', borderRadius:'999px', background:jornadaTodos?'rgba(46,125,50,.08)':'#f4eee6', color:jornadaTodos?'#2E7D32':'#6f6259', fontSize:'13px', fontWeight:800 }}>
              <input type="checkbox" checked={jornadaTodos} onChange={e => setJornadaTodos(e.target.checked)} />
              Liberar para todos
            </label>
          </div>
          {!jornadaTodos && (
            <div style={{ marginTop:'18px', paddingTop:'16px', borderTop:'1px solid rgba(151,142,134,.14)' }}>
              <div style={{ fontSize:'12px', fontWeight:800, color:'#5b402e', marginBottom:'10px', textTransform:'uppercase', letterSpacing:'.07em' }}>Liberar somente para teste</div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(210px,1fr))', gap:'8px', maxHeight:'220px', overflowY:'auto' }}>
                {(alunas || []).filter(aluna => aluna.role !== 'admin').map(aluna => (
                  <label key={aluna.id} style={{ display:'flex', alignItems:'center', gap:'9px', padding:'10px 12px', borderRadius:'14px', background:jornadaAlunas.includes(aluna.id)?'rgba(137,91,64,.09)':'#f7f2ec', color:'#251c19', fontSize:'13px', cursor:'pointer' }}>
                    <input type="checkbox" checked={jornadaAlunas.includes(aluna.id)} onChange={e => setJornadaAlunas(lista => e.target.checked ? [...new Set([...lista, aluna.id])] : lista.filter(id => id !== aluna.id))} />
                    <span><strong style={{ display:'block' }}>{aluna.name}</strong><small style={{ color:'#8c7f70' }}>{aluna.email}</small></span>
                  </label>
                ))}
              </div>
              {(alunas || []).filter(aluna => aluna.role !== 'admin').length === 0 && <div style={muted}>Nenhuma aluna carregada para seleção.</div>}
              <div style={{ ...muted, marginTop:'10px' }}>{jornadaAlunas.length ? `${jornadaAlunas.length} pessoa(s) com acesso de teste.` : 'Sem seleção, a Jornada permanece oculta para todas as alunas.'}</div>
            </div>
          )}
        </div>

        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap', marginBottom: '16px' }}>
            <div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: '#251c19', marginBottom: '5px' }}>Notificações push diárias</div>
              <div style={muted}>Envia uma notificação automática por dia para quem ativou notificações no app. O horário usa o fuso de Fortaleza.</div>
            </div>
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: '9px', color: '#251c19', fontSize: '13px', fontWeight: 800 }}>
              <input type="checkbox" checked={pushAtivo} onChange={e => setPushAtivo(e.target.checked)} />
              Ativar envio diário
            </label>
          </div>
          <div className="admin-config-grid" style={{ display: 'grid', gridTemplateColumns: '160px minmax(0,1fr)', gap: '12px', marginBottom: '12px' }}>
            <label>
              <div style={{ color: '#5b402e', fontSize: '11px', fontWeight: 800, letterSpacing: '.09em', textTransform: 'uppercase', marginBottom: '6px' }}>Horário</div>
              <input type="time" value={pushHora} onChange={e => setPushHora(e.target.value)} style={input} />
            </label>
            <label>
              <div style={{ color: '#5b402e', fontSize: '11px', fontWeight: 800, letterSpacing: '.09em', textTransform: 'uppercase', marginBottom: '6px' }}>Título</div>
              <input value={pushTitulo} onChange={e => setPushTitulo(e.target.value)} placeholder="Team Carol Macedo" style={input} />
            </label>
          </div>
          <label>
            <div style={{ color: '#5b402e', fontSize: '11px', fontWeight: 800, letterSpacing: '.09em', textTransform: 'uppercase', marginBottom: '6px' }}>Mensagens push</div>
            <textarea value={pushMensagens} onChange={e => setPushMensagens(e.target.value)} rows={5} style={{ ...input, resize: 'vertical', lineHeight: 1.55 }} />
          </label>
          <div style={{ ...muted, marginTop: '10px' }}>No futuro, essa mesma base pode enviar lembretes por refeição ou treino usando o horário real do plano da aluna.</div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', flexWrap: 'wrap', marginTop: '6px' }}>
          {msg ? <div style={{ color: msg.includes('Não foi') ? '#C0392B' : '#2E7D32', fontSize: '13px', fontWeight: 700 }}>{msg}</div> : <div style={muted}>Essas opções controlam o que aparece no app das alunas.</div>}
          <button onClick={salvarTudo} disabled={salvando} style={{ border: 0, borderRadius: '999px', background: salvando ? '#A8937A' : '#895b40', color: '#fff9f2', padding: '13px 22px', fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', cursor: salvando ? 'default' : 'pointer', boxShadow: '0 12px 26px rgba(137,91,64,.14)' }}>
            {salvando ? 'Salvando...' : 'Salvar configurações'}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
